import { useState } from "react";
import { FAQS } from "@/mocks/content";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[900px] px-4 md:px-6">
        <div className="mb-10 text-center">
          <p className="mb-2 text-sm font-bold tracking-[0.25em] text-primary-600">FAQ · 常见问题</p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            你可能想问的几件事
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于信源、核实流程、匿名投稿与报道独立性，我们在这里公开作答。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={
                  "overflow-hidden rounded-lg border transition-colors " +
                  (open ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50")
                }
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{f.q}</h3>
                  <span
                    className={
                      "flex h-8 w-8 shrink-0 items-center justify-center rounded-md transition-colors " +
                      (open ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-foreground-700")
                    }
                  >
                    <i className={"ri-add-line transition-transform " + (open ? "rotate-45" : "")}></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 md:px-6">
                    <p className="border-t border-background-200 pt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}